import { usePasteConfig } from '@/components/custom/erp/input-table-v2';

interface UseChiPhiPasteProps {
  columns: MuaHangRecord[];
  handleUpdateNonWritableFields?: (fields: Set<string>) => void;
  handleUpdatePasteConfigs?: (
    configs: Record<string, { resolver: (codes: string[]) => Promise<MuaHangRecord[]>; resultField?: string }>
  ) => void;
}

export const useChiPhiPaste = ({
  columns,
  handleUpdateNonWritableFields,
  handleUpdatePasteConfigs
}: UseChiPhiPasteProps) => {
  return usePasteConfig({
    columns,
    onNonWritableFields: handleUpdateNonWritableFields,
    onPasteConfigs: handleUpdatePasteConfigs
  });
};
